import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Image } from "antd";
import PsContext from "../../context";
import {
  IMAGES_512,
  NO_IMAGE_LOGO_WIDE,
  getFileLiveUrl,
  makeUrl,
} from "../../utils";
import LoaderIcon from "../../utils/LoaderIcon";
import { ServiceUrl } from "../../utils/serviceUrl";

const DepartmentList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [courseType, setCourseType] = useState("");

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    const form = new FormData();
    form.append("show_on_website", 1);
    axios.post(ServiceUrl.DEPARTMENTS, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
        setDataView(res["data"].data);
      }
      setLoader(false);
    });
  };

  const listCourses = (item) => {
    return (
      <Col md={4} className="mb-4">
        <Link to={`/department/${item.id}/${makeUrl(item.department)}`}>
          {/*<Card>
            <Card.Img
              src={getFileLiveUrl(item.department_logo)}
              className="bg-light"
            />
            <Card.Body className="fw-bold text-center text-dark">
              {item.department}
            </Card.Body>
          </Card>*/}
          <div className="home-top-cour py-0">
            <Row style={{ backgroundColor: "#6121d31f" }}>
              <Col md={4} xs={4}>
                <Image
                  src={getFileLiveUrl(item.department_logo)}
                  fallback={IMAGES_512.NO_IMAGE.default}
                  className="w-100"
                  preview={false}
                  style={{ objectFit: "cover", height: "100%" }}
                />
              </Col>

              <Col md={8} xs={8} className="fw-bold text-dark">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "105px" }}
                >
                  DEPARTMENT OF {item.department}
                </div>
              </Col>
            </Row>
          </div>
        </Link>
      </Col>
    );
  };

  return (
    <>
      <section>
        <div className="head-2">
          <div className="container">
            <div className="head-2-inn head-2-inn-padd-top">
              <h1>Departments</h1>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container my-5 pg-inn ps_min_height">
          {loader && <LoaderIcon />}
          <Row>{dataView.map((item) => listCourses(item))}</Row>
        </div>
      </section>
    </>
  );
};

export default DepartmentList;
